// TODO(eslint): fix cycle errors in these imports
/* eslint-disable import/no-cycle */
import {
  CLIENT_ACTION_VALUES,
  COVERAGE_FORM,
  COVERAGE_NAMES,
} from "@platform/rfp-core";

import { initialAccidentCoveragesDetails } from "./Accident";
import { initialBasicLifeCoveragesDetails } from "./BasicLifeAD&D";
import {
  initialDentalCoveragesDetails,
  getInitialDentalCoveragesDetails,
} from "./Dental";
import { initialEmployeesCoveragesDetails } from "./EmployeeAssistanceProgram";
import { initialFMLACoveragesDetails } from "./FamilyMedicalLeaveAdministration";
import { initialIndividualDisabilityCoveragesDetails } from "./IndividualDisability";
import { initialLTDCoveragesDetails } from "./LongTermDisability";
import { initialSTDCoveragesDetails } from "./ShortTermDisability";
import { initialSDLCoveragesDetails } from "./StateDisabilityLeaves";
import { initVisionCoveragesDetails } from "./Vision";
import { initialVLADDDCoveragesDetails } from "./VoluntaryLifeADD";
import { coveragesValidations } from "./coveragesValidations";

const { PLANS } = COVERAGE_FORM;

const {
  ACCIDENT,
  VISION,
  CANCER,
  CI,
  HOSPITAL,
  WHOLE_LIFE,
  LTD,
  FMLA,
  BASIC_LIFE,
  VOLUNTARY_LIFE,
  STD,
  EAP,
  DENTAL,
  DENTAL_PPO,
  DENTAL_DHMO,
  INDIVIDUAL_DISABILITY,
  SDL,
} = COVERAGE_NAMES;

const { IS_CURRENT_CLIENT } = CLIENT_ACTION_VALUES;
const { IS_CURRENT_COVERAGE } = COVERAGE_FORM;
export const isValidPlan = (errors) =>
  errors ? !Object.values(errors)?.some((v) => !!v) : true;

export const initDetailsValues = (name) => {
  switch (name) {
    case VISION:
      return initVisionCoveragesDetails;
    case ACCIDENT:
    case CANCER:
    case CI:
    case HOSPITAL:
    case WHOLE_LIFE:
      return initialAccidentCoveragesDetails;
    case LTD:
      return initialLTDCoveragesDetails;
    case FMLA:
      return initialFMLACoveragesDetails;
    case BASIC_LIFE:
      return initialBasicLifeCoveragesDetails;
    case VOLUNTARY_LIFE:
      return initialVLADDDCoveragesDetails;
    case STD:
      return initialSTDCoveragesDetails;
    case EAP:
      return initialEmployeesCoveragesDetails;
    case DENTAL:
      return initialDentalCoveragesDetails;
    case DENTAL_PPO:
      return getInitialDentalCoveragesDetails(DENTAL_PPO);
    case DENTAL_DHMO:
      return getInitialDentalCoveragesDetails(DENTAL_DHMO);
    case INDIVIDUAL_DISABILITY:
      return initialIndividualDisabilityCoveragesDetails;
    case SDL:
      return initialSDLCoveragesDetails;
    default:
      return null;
  }
};

export const coverages = {
  ...Object.values(COVERAGE_NAMES).reduce(
    (acc, key) => ({
      ...acc,
      [key]: (value) => {
        const plans = value.details?.plans.reduce(
          (acc, p) => [
            ...acc,
            {
              ...p,
              errors: coveragesValidations[key]({
                ...p,
                [IS_CURRENT_CLIENT]: value[IS_CURRENT_CLIENT],
                [IS_CURRENT_COVERAGE]: value[IS_CURRENT_COVERAGE],
              }),
            },
          ],
          [],
        );
        const isValid = !plans?.some((p) => !isValidPlan(p.errors));
        return {
          ...value,
          details: { ...value.details, [PLANS]: plans },
          isValid,
        };
      },
    }),
    {},
  ),
};
